import RegionOverview from './RegionOverview'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selectedRegionId,
    regionsData: state.REGIONS.regionsData,
    countriesData: state.REGIONS.countriesData
  }
}

export default withRouter( connect(mapStateToProps)(RegionOverview) )



// WEBPACK FOOTER //
// ./src/components/RegionOverview/index.js